/**
 * Functions for sending OAuth2 requests to the server.
 */
import { SagaIterator } from 'redux-saga'
import { call, put } from 'redux-saga/effects'
import { Action, AsyncActionCreators } from 'typescript-fsa'
import { ResponseError } from './types'

/** A generic function for calling API while calling typescript-fsa async action's done and failed
 * actions.
 */
export function* callApi<A, B>(
	action: Action<A>,
	async: AsyncActionCreators<A, B, ResponseError>,
	func: (payload: A, options: RequestInit) => Promise<B>,
	retry: boolean = true,
): SagaIterator {
	/* Check if there are any offline changes queued, and don't allow GET requests through, as we
	   might load information that would replace our pending changes in the state, such as resetting
	   a job state back to the server state, before we've had a chance to POST the change.
	 */
	// const queueLength = (yield select(selectOfflineOutboxQueueLength)) as number
	// if (queueLength > 0) {
	// 	let error = new Error('Offline changes are queued')

	// 	yield put(async.failed({ params: action.payload, error: (error as {}) as C }))
	// 	return
	// }

	try {
		let result = yield call(() => {
			return func(action.payload, {})
		})

		yield put(async.done({ params: action.payload, result }))
	} catch (error) {
		if ((error as ResponseError).status === 401) {
			if (retry) {
				// console.log('Refreshing access token after API call failed', action.type, error)

				// todo put refresh token saga in
				// const refreshResult = yield call(refreshTokenNow)
				const refreshResult = undefined

				if (refreshResult) {
					// console.log('Refreshing access token was successful, retrying API call', action.type)
					// @ts-ignore
					yield call(callApi, action, async, func, false)
					return
				} else {
					// console.log('Refreshing access token failed, failing API call', action.type)
				}
			}
		}
		yield put(async.failed({ params: action.payload, error: error as ResponseError }))
	}
}
